<template>
  <div class="we-medial-container">
    <Card title="基础信息">
      <a-tabs
        v-model="tabCurrent"
        v-if="$route.query.type === 'twitter' && !editId"
        @change="tabChange"
      >
        <a-tab-pane key="user" tab="用户" :disabled="!!editId"></a-tab-pane>
        <a-tab-pane key="key" tab="关键词" :disabled="!!editId"></a-tab-pane>
      </a-tabs>

      <a-form-model
        class="ant-advanced-search-form"
        :model="siteForm"
        layout="horizontal"
        :labelCol="{ span: 5 }"
        :wrapperCol="{ span: 18, offset: 1 }"
        :rules="rules"
        ref="form"
      >
        <div class="form-container">
          <a-form-model-item label="站点类型" required>
            <a-input disabled v-model="siteForm.spiderClassType" size="large" />
          </a-form-model-item>

          <a-form-model-item label="国家" required prop="countryCode">
            <CountrySelect v-model="siteForm.countryCode" size="large" />
          </a-form-model-item>

          <a-form-model-item v-if="tabCurrent === 'user'" label="用户ID" required prop="accountId">
            <div style="display: flex">
              <a-input style="flex: 1" v-model="siteForm.accountId" size="large" />
              <Avatar
                v-if="siteForm.accountId != ''"
                style="margin-left: 10px"
                :spiderId="$route.query.spiderId"
                :address="siteForm.accountId"
                :type="$route.query.type"
              />
            </div>
          </a-form-model-item>

          <a-form-model-item label="语言" required prop="langCode">
            <LangSelect v-model="siteForm.langCode" size="large" />
          </a-form-model-item>

          <a-form-model-item
            label="用户名称"
            v-if="tabCurrent === 'user'"
            required
            prop="accountName"
          >
            <a-input v-model="siteForm.accountName" size="large" />
          </a-form-model-item>

          <a-form-model-item label="调度周期时间" prop="spiderExecTimeCycle">
            <a-input-group compact>
              <a-input-number
                :min="1"
                :max="max"
                style="width: calc(100% - 90px)"
                v-model="siteForm.spiderExecTimeCycle"
                size="large"
              >
              </a-input-number>
              <a-select style="width: 90px" v-model="siteForm.spiderExecTimeType" size="large">
                <a-select-option :value="0"> 秒/次 </a-select-option>
                <a-select-option :value="1"> 分/次 </a-select-option>
                <a-select-option :value="2"> 时/次 </a-select-option>
                <a-select-option :value="3"> 天/次 </a-select-option>
                <a-select-option :value="4"> 月/次</a-select-option>
              </a-select>
            </a-input-group>
          </a-form-model-item>

          <a-form-model-item
            label="账号描述"
            v-if="tabCurrent === 'user'"
            required
            prop="accountDesc"
          >
            <a-textarea v-model="siteForm.accountDesc" size="large" />
          </a-form-model-item>

          <a-form-model-item
            label="站点名称"
            v-if="tabCurrent === 'key'"
            required
            prop="spiderName"
          >
            <a-input v-model="siteForm.spiderName" size="large" />
          </a-form-model-item>

          <a-form-model-item label="关键词" v-if="tabCurrent === 'key'" prop="spiderUrls">
            <a-input
              type="text"
              v-model="singleKey"
              @keyup.enter.native="addKey"
              placeholder="按回车键添加关键词"
            ></a-input>
            <ul
              style="
                margin-top: 10px;
                display: flex;
                flex-wrap: wrap;
                max-height: 150px;
                overflow-y: auto;
              "
            >
              <li class="keyword" v-for="(item, i) in siteForm.spiderUrls" :key="i">
                {{ item }}
                <a-icon
                  @click="siteForm.spiderUrls.splice(i, 1)"
                  type="minus-circle"
                  class="delete-key"
                />
              </li>
            </ul>
          </a-form-model-item>

          <a-form-model-item label="IP代理">
            <a-radio-group button-style="solid" v-model="siteForm.ipConfig.enabled">
              <a-radio-button :value="0"> 关 </a-radio-button>
              <a-radio-button :value="1"> 开 </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
            v-if="siteForm.ipConfig.enabled == 1"
            label="代理国家"
            :prop="Boolean(siteForm.ipConfig.enabled) ? 'ipConfigCountry' : ''"
          >
            <CountrySelect v-model="siteForm.ipConfigCountry" />
          </a-form-model-item>

          <a-form-model-item
            v-if="siteForm.ipConfig.enabled == 1"
            label="代理数量"
            :prop="Boolean(siteForm.ipConfig.enabled) ? 'ipConfigNum' : ''"
          >
            <a-input-number
              :min="1"
              v-model="siteForm.ipConfigNum"
              style="width: 100%"
              placeholder="请输入IP代理数量"
            />
          </a-form-model-item>

          <a-form-model-item label="标签设置" prop="spiderTags">
            <div class="tags-inner">
              <Tag
                v-for="(tag, index) in siteForm.spiderTags"
                :onDelete="() => onSelectTag(tag)"
                :key="index"
                class="atag"
              >
                <a-tooltip :title="tag.spiderTagName" :delay="1000">
                  {{ tag.spiderTagName }}
                </a-tooltip>
              </Tag>
              <div class="add-tag" @click="isShowTagSelectorModal = true">+ 添加标签</div>
            </div>
          </a-form-model-item>
        </div>
      </a-form-model>
    </Card>
    <div class="bts-container">
      <a-button
        type="primary"
        size="large"
        :style="{ width: '120px', display: 'block', marginBottom: '12px' }"
        @click="back()"
        v-if="editId"
        >返回</a-button
      >
      <a-button
        type="primary"
        size="large"
        :style="{ width: '120px' }"
        :loading="submitLoading"
        @click="handleSubmit"
        >{{ editId ? '修改' : '创建' }}</a-button
      >
    </div>

    <a-modal
      title="选择标签"
      :visible="isShowTagSelectorModal"
      okText="确定"
      cancelText="取消"
      :closable="false"
      @cancel="isShowTagSelectorModal = false"
      @ok="isShowTagSelectorModal = false"
      :width="725"
    >
      <div class="tags-modal-contianer">
        <Tag
          v-for="(tag, index) in labels"
          :key="index"
          :isActive="siteForm.spiderTags.map((t) => t.spiderTagId).includes(tag.spiderTagId)"
          :onSelect="() => onSelectTag(tag)"
          :canDelete="false"
        >
          <a-tooltip :title="tag.spiderTagName" :delay="1000">
            {{ tag.spiderTagName }}
          </a-tooltip>
        </Tag>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  addSpiderTwitterItemApi,
  getSpiderTwitterByIdApi,
  updateSpiderTwitterItemApi,
  queryTagListApi
} from '@/api/Site/Create'
import Card from '../components/Card'
import LangSelect from '@/components/LangSelect/'
import CountrySelect from '@/components/CountrySelect/'
import WeMediaOptions from './options'
import { onHttpResponseSilent } from '../../../../utils/request'
import Tag from '../components/Tag'
import Avatar from '@/components/Avatar/'

export default {
  props: {
    onSubmited: {
      type: Function
    }
  },

  components: {
    Avatar,
    LangSelect,
    CountrySelect,
    Card,
    Tag
  },
  data() {
    return {
      min: 1,
      siteForm: {
        spiderId: undefined,
        spiderName: undefined,
        spiderClassId: undefined,
        spiderClassType: undefined,
        accountId: undefined,
        accountName: undefined,
        accountDesc: undefined,
        ipConfigCountry: 'us',
        countryCode: 'cn',
        langCode: 'zh',
        spiderLevel: 2,
        deployType: 0,
        spiderExecTimeType: 1,
        spiderExecTimeCycle: 10,
        execType: null,
        spiderTags: [],
        spiderUrls: [],
        ipConfigNum: 2,
        ipConfig: {
          enabled: 1
          // url: 'http://ip-pool-service-master-starsee.prod.k8s.starsee.it/ip_pool/getIp?num=3&type=2&country=cn'
        }
      },
      singleKey: undefined,
      rules: {
        countryCode: [{ required: true, message: '国家必填', trigger: 'change' }],
        langCode: [{ required: true, message: '语言必填', trigger: 'change' }],
        spiderName: [{ required: true, message: '站点名称必填', trigger: 'blur' }],
        accountId: [{ required: true, message: '用户ID必填', trigger: 'blur' }],
        accountName: [{ required: true, message: '用户名称必填', trigger: 'blur' }],
        accountDesc: [{ required: true, message: '账号描述必填', trigger: 'blur' }],
        ipConfigCountry: [{ required: true, message: '代理国家必填', trigger: 'change' }],
        ipConfigNum: [{ required: true, message: '代理数量必填', trigger: 'blur' }],
        spiderUrls: [{ required: true, message: '关键词必填', trigger: 'blur' }]
        // spiderExecTimeCycle: {
        //   required: true,
        //   type: 'number',
        //   asyncValidator: (_, value) => {
        //     return new Promise((resolve, reject) => {
        //       if (value >= 1 && value <= this.max) {
        //         resolve()
        //       } else {
        //         reject('时间周期不合法')
        //       }
        //     })
        //   },
        //   trigger: 'change'
        // }
      },
      editId: '',
      submitLoading: false,

      isShowTagSelectorModal: false,
      labels: [],
      tabCurrent: 'user'
    }
  },
  computed: {
    max() {
      let { spiderExecTimeType } = this.siteForm
      if (spiderExecTimeType == 0 || spiderExecTimeType == 1) {
        return 59
      } else if (spiderExecTimeType == 2) {
        return 23
      } else if (spiderExecTimeType == 3) {
        return 31
      } else {
        return 12
      }
    }
  },

  created() {
    this.getLabels()
    let { spiderId } = this.$route.query
    if (spiderId) {
      // 这是修改
      this.getSpiderById(spiderId)
      this.editId = spiderId
    } else {
      // 这是新建
      const { spiderClassId, type } = this.$route.query
      this.siteForm.spiderClassId = Number(spiderClassId)
      this.siteForm.spiderClassType = type
      if (type == 'youtube') {
        this.siteForm.countryCode = 'us'
        this.siteForm.langCode = 'en'
      }

      if (WeMediaOptions[type]) {
        this.siteForm.deployType = WeMediaOptions[type].deployType
        this.siteForm.ipConfig.url = WeMediaOptions[type].ipConfigUrl
      }
    }
  },

  methods: {
    back() {
      sessionStorage.types = 'zimeiti'
      this.$router.back(-1)
    },
    addKey() {
      if (this.singleKey) {
        this.siteForm.spiderUrls.push(this.singleKey)
        this.singleKey = undefined
      } else {
        this.$message.error('请输入关键字')
      }
    },
    tabChange(key) {
      this.tabCurrent = key
      if (key === 'key') {
        this.siteForm.spiderUrls = []
      }
    },

    getLabels() {
      queryTagListApi({
      })
        .then(onHttpResponseSilent)
        .then(({ data }) => {
          this.labels = data
        })
    },

    onSelectTag(tag) {
   
      if (this.siteForm.spiderTags.map((t) => t.spiderTagId).includes(tag.spiderTagId)) {
        this.siteForm.spiderTags = this.siteForm.spiderTags.filter(
          (t) => t.spiderTagId !== tag.spiderTagId
        )
      } else {
        this.siteForm.spiderTags.push(tag)
      }
    },

    reset() {
      if (this.editId) {
        let { spiderId } = this.$route.query
        this.getSpiderById(spiderId)
      } else {
        this.siteForm.countryCode = 'cn'
        this.siteForm.langCode = 'zh'
        this.siteForm.accountId = ''
        this.siteForm.accountName = ''
        this.siteForm.spiderExecTimeType = 1
        this.siteForm.spiderExecTimeCycle = 10
        this.siteForm.accountDesc = ''
        this.siteForm.spiderTags = []
        this.siteForm.ipConfig = {
          enabled: 0,
          url:
            'http://ip-pool-service-master-starsee.prod.k8s.starsee.it/ip_pool/getIp?num=3&type=2&country=cn'
        }
      }
    },

    async getSpiderById(spiderId) {
      let res = await getSpiderTwitterByIdApi({ spiderId })

      let { code, msg, extra } = res
      if (code === 200) {
        this.siteForm = extra.spiderTwitter
        if (
          this.siteForm.spiderUrls &&
          this.siteForm.spiderUrls.length &&
          this.siteForm.spiderName
        ) {
          this.tabCurrent = 'key'
        } else {
          this.tabCurrent = 'user'
        }
      } else {
        this.$message.error(msg)
      }
    },
    getPostData() {
      return {
        ...this.siteForm,
        mqConfig: window.spider.default.mqConfig
      }
    },

    async addSpiderItem() {
      return new Promise((resolve, reject) => {
        this.$confirm({
          title: '调度任务确认',
          content: '是否立刻开启调度任务?',
          autoFocusButton: 'ok',
          cancelText: '暂不开启',
          okText: '立即开启',
          onOk: async () => {
            await this._addSpiderItem(true)
            resolve()
          },
          onCancel: async () => {
            await this._addSpiderItem(false)
            resolve()
          }
        })
      })
    },

    async _addSpiderItem(runNow) {
      this.submitLoading = true
      let postData = this.getPostData()
      if (runNow) {
        postData.execType = 1
      }
      let res = await addSpiderTwitterItemApi(postData)
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.$router.push({ name: 'site_manage', query: { type: 'weMedia' } })
      } else {
        this.$message.error(msg)
        this.submitLoading = true
      }
    },

    async updateSpiderItem() {
      let postData = this.getPostData()
      if (
        postData.spiderClassType === 'vk' ||
        postData.spiderClassType === 'ins' ||
        postData.spiderClassType === 'tg'
      ) {
        postData.deployType = 1
      }
      let res = await updateSpiderTwitterItemApi(postData)
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        if (this.onSubmited) {
          this.onSubmited(res)
        } else {
          this.$router.push({ name: 'site_manage', query: { type: 'weMedia' } })
        }
      } else {
        this.$message.error(msg)
      }
    },

    async handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.tabCurrent === 'user') {
            delete this.siteForm.spiderUrls
            delete this.siteForm.spiderName
          } else {
            delete this.siteForm.accountId
            delete this.siteForm.accountName
            delete this.siteForm.accountDesc
          }

          if (this.editId) {
            this.submitLoading = true
            this.updateSpiderItem()
          } else {
            this.addSpiderItem()
          }
          this.submitLoading = false
        } else {
          this.$message.error('表单填写不完整，请检查表单')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.we-medial-container {
  width: calc(100% - 200px);
  position: relative;

  .form-container {
    width: 100%;
    display: grid;
    grid-template-columns: 45% 45%;
    gap: 0 60px;

    .tags-inner {
      display: grid;
      grid-template-columns: repeat(auto-fill, 86px);
      gap: 10px;

      .add-tag {
        width: 100%;
        height: 36px;
        border-radius: 4px;
        background: #f5f6fa;
        color: #3c93ff;
        border: none;
        line-height: 34px;
        text-align: center;
        cursor: pointer;
      }
    }
  }

  .bts-container {
    position: absolute;
    right: -180px;
    bottom: 0px;
  }

  .news-btns {
    text-align: center;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
  }
}

.tags-modal-contianer {
  display: grid;
  grid-template-columns: repeat(auto-fill, 88px);
  gap: 10px;
}
.atag:hover {
  background: #3c93ff;
  color: #fff;
}
.keyword {
  padding: 0 10px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  background: #f5f6fa;
  border-radius: 4px;
  position: relative;
  margin: 10px 10px 0 0;
  .delete-key {
    display: none;
    color: red;
    position: absolute;
    top: -5px;
    right: -5px;
  }
}
.keyword:hover {
  .delete-key {
    display: block;
    cursor: pointer;
  }
}
</style>
